import React, { useContext, useEffect } from "react";
import Sidebar from "../../Components/Sidebar/sidebar";
import { Layout } from "antd";
import { Routes, Route } from 'react-router-dom';
import HeaderNav from "../../Components/Header/Header";
import DeckleOrdersData from "./DeckleOrders/deckleOrders";
import JobCardsData from "./JobCards/jobCards";
import PaperMachineData from "./PaperMachine/paperMachine";
import OrderSummaryData from "./JobCards/orderSummaryTable";
import PrepareJobData from "./JobCards/preparingJobCard";
import ReviewSelectedOrdersData from "./JobCards/reviewSelectedOrders";
import DeckleResultsData from "./DeckleResults/deckleMatchResults";
import JobCardDetailData from "./JobCards/jobCardDetails";
import PrintJobCardDetails from "../Print/printJobCardDetails";
import ExportOrders from "../OrderEntry/ExportOrders/exportOrders";
import ExportOrdersPdf from "../Exports/exportOrdersPdf";
import ExportRecordsAnimation from "../Exports/exportRecordsAnimationScreen";
import PaperMachineOrders from "./JobCards/PaperMachineOrders";
import { useLocation } from "react-router";
import SheetJobCardDetailData from "./JobCards/SheetJobCardDetails";
import PrintSheetJobCardDetails from "../Print/printSheetJobCardDetails";
import SheetDeckleResultsData from "./DeckleResults/SheetDeckleMatchResult";
import PrintDuplexJobCardDetails from "../Print/printDuplexJobCardDetails";
import LogTable from "../../Components/Log/logTable"
import PoDetailsData from "../OrderEntry/AddNewPO/poDetails";
import OrderDetailsData from "../OrderEntry/AddNewPO/orderDetails";
import PaperMachineSelectedOrder from "./JobCards/paperMachineSelectedOrder";
import DeckleMatchResultsMultistage from "./DeckleResults/deckleMatchResultsMultistage";
import DeckleMatchResultsMultistageMultipleSol from "./DeckleResults/deckleMatchResultsMultistageMultipleSol";
import JobcardDetailsMultistage from "./JobCards/jobCardDetailsMultistage";
import PrintMultiStageJobCardDetails from "../Print/printMultiStageJobCardDetails";
import PrintJobCardPdf from "../Print/printJobCardsPdf.jsx";
import PrintParentReelPdf from "../Print/printParentReel";
import AddNewSoData from "../OrderEntry/AddNewPO/addNewSO.jsx";
import JobcardSummaryReport from "./JobCards/JobcardSummaryReport.jsx";
import JobCardDataContext from "../../ContextApi/JobCardDataContext.jsx";
import JobCardDetailsViewer from "./JobCards/JobCardDetailsViewer.jsx";
const { Content } = Layout;

const listItems = [
    {
        icon: 'jobcard-icon',
        label: 'Job Cards',
        link: 'job-cards'
    },
    {
        icon: 'order-entry-icon',
        label: 'Order Records',
        link: 'order-records'
    },
];


const DeckleMatchingData = props => {
    
    var sidebar_collapsed = true;
    
    /*
    TODO: Instead of local, Storing/Fetching this data from backend to hide status for only jobcards page
    TODO: Storing data, PUT /profile-settings/?ui
    TODO: Fetching data and updating data, GET /user-profile/

    const location = useLocation();
    if (location.pathname == "/deckle-matching/job-cards") {
        if (sidebar_collapsed == false) {
            sidebar_collapsed = true;
        }
    } else {
        if (sidebar_collapsed) {
            sidebar_collapsed = false;
        }
    }*/

          const {handleFilterReset}=useContext(JobCardDataContext)
        
      useEffect(() => {
  return () => {
    console.log("cleanup / unmounted");
    handleFilterReset()
  };
}, []);


    return (
        <Layout>
            <HeaderNav />
            <Layout>
                <Sidebar headerName="DECKLE MANAGEMENT" listItems={listItems} is_collapsed={sidebar_collapsed} />
                <Layout>
                    <Content>
                        <Routes>
                        <Route path="order-records" element={<DeckleOrdersData />} />
                        <Route path="order-records/export-orders" element={<ExportOrders />} />
                        <Route path="order-records/export-orders/pdf" element={<ExportOrdersPdf />} />
                        <Route path="job-cards" element={<JobCardsData />} />
                        <Route path="create-new-job-cards" element={<PaperMachineData/>}/>
                        <Route path="order-summary" element={<OrderSummaryData/>}/>
                        <Route path="preparing-job-card" element={<PrepareJobData/>}/>
                        <Route path="review-selected-order" element={<ReviewSelectedOrdersData/>}/>
                        <Route path="deckle-match-result" element={<DeckleResultsData/>}/>
                        <Route path="so-details" element={<AddNewSoData />} />
                        <Route path="deckle-match-result/print" element={<PrintJobCardDetails/>}/>
                        <Route path="job-card-details" element={<JobCardDetailData/>}/>
                        <Route path="job-card-details/print" element={<PrintJobCardDetails/>}/>
                        <Route path="order-records/preparing-export-orders" element={<ExportRecordsAnimation />}/>
                        <Route path="paper-machine-orders" element={<PaperMachineOrders/>}/>
                        <Route path="sheet-job-card-details" element={<SheetJobCardDetailData/>}/>
                        <Route path="sheet-job-card-details/print" element={<PrintSheetJobCardDetails/>}/>
                        <Route path="sheet-job-card-details/duplex-print" element={<PrintDuplexJobCardDetails/>}/>
                        <Route path="sheet-deckle-match-result" element={<SheetDeckleResultsData/>}/>
                        <Route path="history" element={<LogTable />} />
                        <Route path="po-details" element={<PoDetailsData />} />
                        <Route path="order-details" element={<OrderDetailsData/>}/>
                        <Route path="paper-machine-selected-order" element={<PaperMachineSelectedOrder/>}/>
                        <Route path="job-card-details-multistage" element={<JobcardDetailsMultistage/>}/>
                        <Route path="deckle-match-result-multistage" element={<DeckleMatchResultsMultistage/>}/>
                        <Route path="deckle-match-result-multistage-multi-solutions" element={<DeckleMatchResultsMultistageMultipleSol/>}/>
                        <Route path="job-card-details-multistage/print" element={<PrintMultiStageJobCardDetails/>}/>
                        <Route path="job-card-details/print-job-card/pdf" element={<PrintJobCardPdf />} />
                        <Route path="deckle-job-cards/job-card-details/print-job-card/pdf" element={<PrintJobCardPdf />} />
                        <Route path="job-card-details/print-parent-reel/pdf" element={<PrintParentReelPdf />} />
                        <Route path="job-card-details-multistage/print-parent-reel/pdf" element={<PrintParentReelPdf />} />
                        <Route path="job-card-summary-report" element={<JobcardSummaryReport />} />
                        <Route path="job-card-details/viewer" element={<JobCardDetailsViewer/>}/>
                        </Routes>
                    </Content>
                </Layout>
            </Layout>
        </Layout>
    );
}

export default DeckleMatchingData;